import entryFansCircle from "@/assets/imgs/home/entry-fans-circle.png";
import entryRanking from "@/assets/imgs/home/entry-ranking.png";
import entrySchedule from "@/assets/imgs/home/entry-schedule.png";
import entryScorer from "@/assets/imgs/home/entry-scorer.png";
import entryTicket from "@/assets/imgs/home/entry-ticket.png";
import heroBackground from "@/assets/imgs/home/hero-background.png";
import heroBanner from "@/assets/imgs/home/hero-banner.png";
import livePlayerPlaceholder from "@/assets/imgs/home/live-player-placeholder.png";
import pageTexture from "@/assets/imgs/home/page-texture.png";
import spotlightCover from "@/assets/imgs/home/spotlight-cover.png";

const homeMock = {
  share: {
    title: "长江云新闻带你看楚超",
    desc: "楚超来了！快来为你喜欢的球队加油助威！",
    imgUrl:
      "https://res.cjyun.org/a/10008/202604/210ef749edcb8da76de14d047bae11e2.png",
    link: "https://m.hbtv.com.cn/huodong/hubei-football-league",
  },
  hero: {
    pageTexture,
    background: heroBackground,
    banner: heroBanner,
  },
  live: {
    listId: 3822,
    pageSize: 5,
    source:
      "https://videos.jstv.com/video/2025/11/04/202511041532301762241550913_867.mp4",
    cover: livePlayerPlaceholder,
    autoplay: false,
    isLive: true,
  },
  quickEntries: [
    {
      key: "schedule",
      label: "赛程",
      icon: entrySchedule,
    },
    {
      key: "ranking",
      label: "积分榜",
      icon: entryRanking,
    },
    {
      key: "ticket",
      label: "购票",
      icon: entryTicket,
    },
    {
      key: "scorer",
      label: "射手榜",
      icon: entryScorer,
    },
    {
      key: "circle",
      label: "粉丝圈",
      icon: entryFansCircle,
    },
  ],
  categories: [
    {
      key: "all",
      label: "全部",
      listId: 3812,
      url: "3812",
      pageSize: 5,
      sectionType: "feed",
    },
    {
      key: "highlights",
      label: "赛事集锦",
      listId: 3813,
      url: "3813",
      pageSize: 3,
      sectionType: "feature",
    },
    {
      key: "live",
      label: "赛程直播",
      listId: 3814,
      url: "3814",

      // listId: 3321,
      // url: "3321",
      pageSize: 6,
      sectionType: "live",
    },
    {
      key: "community",
      label: "“楚超”朋友圈",
      listId: 3815,
      url: "3815",
      pageSize: 3,
      sectionType: "feature",
    },
    {
      key: "reviews",
      label: "大家评“楚超”",
      listId: 3816,
      url: "3816",
      pageSize: 2,
      sectionType: "feature",
    },
  ],
  highlight: {
    cover: spotlightCover,
    url: "https://m.hbtv.com.cn/p/4596940.html",
  },
};

export default homeMock;
